<template>
  <div class="lock" v-if="isShow">
    <div class="message">
      <div class="loading-w">
        loading
        <!-- <img src="@/assets/images/loading.gif"/> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: true,
    }
  },
  methods: {}
}
</script>
<style lang="less" scoped>

.lock {
  position: fixed;
  z-index: 1000;
  background-color: rgba(0,0,0,0.2);
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;

  .message {
    position: fixed;
    z-index: 1001;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .loading-w {
      width: 60px;
      height: 60px;
      background-color: #dadada;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 32px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message/loading.vue